 
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const GetReservationsDocument = gql`
    query GetReservations($search: String, $statuses: [ReservationStatus!], $page: Int, $perPage: Int, $sort: [ReservationSortInput!]!, $date: Date) {
  reservations(
    search: $search
    statuses: $statuses
    page: $page
    perPage: $perPage
    sort: $sort
    date: $date
  ) {
    reservations {
      id
      uuid
      branch {
        name
        address
        phones {
          phone
        }
        generalWorkSchedules {
          id
          day {
            id
            name
            shortName
            number
          }
          period
        }
        countryProxy {
          slug
        }
        city {
          slug
        }
        branchDetails {
          slug
        }
        branchDetails {
          formatedAddress
        }
      }
      customPlace {
        id
        name
        location
        country {
          id
          name
        }
      }
      client {
        name
        surname
        phone
        email
      }
      reservationAt(format: "Y-m-d H:i:s")
      flexibility
      guestsCount
      comment
      moderatorComment
      status
      createdAt(format: "Y-m-d H:i:s")
      updatedAt(format: "Y-m-d H:i:s")
      isPremium
    }
    totalCount
    currentPage
    itemsPerPage
    pageCount
  }
}
    `;

/**
 * __useGetReservationsQuery__
 *
 * To run a query within a React component, call `useGetReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservationsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      statuses: // value for 'statuses'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      sort: // value for 'sort'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useGetReservationsQuery(baseOptions: Apollo.QueryHookOptions<GetReservationsQuery, GetReservationsQueryVariables> & ({ variables: GetReservationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReservationsQuery, GetReservationsQueryVariables>(GetReservationsDocument, options);
      }
export function useGetReservationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReservationsQuery, GetReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReservationsQuery, GetReservationsQueryVariables>(GetReservationsDocument, options);
        }
export function useGetReservationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReservationsQuery, GetReservationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReservationsQuery, GetReservationsQueryVariables>(GetReservationsDocument, options);
        }
export type GetReservationsQueryHookResult = ReturnType<typeof useGetReservationsQuery>;
export type GetReservationsLazyQueryHookResult = ReturnType<typeof useGetReservationsLazyQuery>;
export type GetReservationsSuspenseQueryHookResult = ReturnType<typeof useGetReservationsSuspenseQuery>;
export type GetReservationsQueryResult = Apollo.QueryResult<GetReservationsQuery, GetReservationsQueryVariables>;
export const GetReservationByIdDocument = gql`
    query GetReservationById($id: Int!) {
  reservationById(id: $id) {
    id
    uuid
    branch {
      name
      address
      phones {
        phone
      }
      generalWorkSchedules {
        id
        day {
          id
          name
          shortName
          number
        }
        period
      }
      countryProxy {
        slug
      }
      city {
        slug
      }
      branchDetails {
        slug
      }
      branchDetails {
        formatedAddress
      }
    }
    customPlace {
      id
      name
      location
      country {
        id
        name
      }
    }
    client {
      name
      surname
      phone
      email
    }
    reservationAt(format: "Y-m-d H:i:s")
    flexibility
    guestsCount
    comment
    moderatorComment
    status
    createdAt(format: "Y-m-d H:i:s")
    updatedAt(format: "Y-m-d H:i:s")
    isPremium
  }
}
    `;

/**
 * __useGetReservationByIdQuery__
 *
 * To run a query within a React component, call `useGetReservationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservationByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReservationByIdQuery(baseOptions: Apollo.QueryHookOptions<GetReservationByIdQuery, GetReservationByIdQueryVariables> & ({ variables: GetReservationByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReservationByIdQuery, GetReservationByIdQueryVariables>(GetReservationByIdDocument, options);
      }
export function useGetReservationByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReservationByIdQuery, GetReservationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReservationByIdQuery, GetReservationByIdQueryVariables>(GetReservationByIdDocument, options);
        }
export function useGetReservationByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReservationByIdQuery, GetReservationByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReservationByIdQuery, GetReservationByIdQueryVariables>(GetReservationByIdDocument, options);
        }
export type GetReservationByIdQueryHookResult = ReturnType<typeof useGetReservationByIdQuery>;
export type GetReservationByIdLazyQueryHookResult = ReturnType<typeof useGetReservationByIdLazyQuery>;
export type GetReservationByIdSuspenseQueryHookResult = ReturnType<typeof useGetReservationByIdSuspenseQuery>;
export type GetReservationByIdQueryResult = Apollo.QueryResult<GetReservationByIdQuery, GetReservationByIdQueryVariables>;
export const ReservationChangeStatusDocument = gql`
    mutation ReservationChangeStatus($uuid: Uuid!, $status: ReservationStatus!, $comment: String) {
  reservationChangeStatus(uuid: $uuid, status: $status, comment: $comment) {
    id
    uuid
    reservationAt(format: "Y-m-d H:i:s")
    flexibility
    guestsCount
    comment
    moderatorComment
    status
    createdAt(format: "Y-m-d H:i:s")
    updatedAt(format: "Y-m-d H:i:s")
  }
}
    `;
export type ReservationChangeStatusMutationFn = Apollo.MutationFunction<ReservationChangeStatusMutation, ReservationChangeStatusMutationVariables>;

/**
 * __useReservationChangeStatusMutation__
 *
 * To run a mutation, you first call `useReservationChangeStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReservationChangeStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reservationChangeStatusMutation, { data, loading, error }] = useReservationChangeStatusMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      status: // value for 'status'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useReservationChangeStatusMutation(baseOptions?: Apollo.MutationHookOptions<ReservationChangeStatusMutation, ReservationChangeStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReservationChangeStatusMutation, ReservationChangeStatusMutationVariables>(ReservationChangeStatusDocument, options);
      }
export type ReservationChangeStatusMutationHookResult = ReturnType<typeof useReservationChangeStatusMutation>;
export type ReservationChangeStatusMutationResult = Apollo.MutationResult<ReservationChangeStatusMutation>;
export type ReservationChangeStatusMutationOptions = Apollo.BaseMutationOptions<ReservationChangeStatusMutation, ReservationChangeStatusMutationVariables>;
export type GetReservationsQueryVariables = Types.Exact<{
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
  statuses?: Types.InputMaybe<Array<Types.ReservationStatus> | Types.ReservationStatus>;
  page?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  perPage?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  sort: Array<Types.ReservationSortInput> | Types.ReservationSortInput;
  date?: Types.InputMaybe<Types.Scalars['Date']['input']>;
}>;


export type GetReservationsQuery = { __typename?: 'bookingRestaurantQuery', reservations?: { __typename?: 'ReservationPaginated', totalCount?: number | null, currentPage?: number | null, itemsPerPage?: number | null, pageCount?: string | null, reservations?: Array<{ __typename?: 'ReservationProxy', id: number, uuid: any, reservationAt: string, flexibility: Types.ReservationFlexibility, guestsCount: number, comment?: string | null, moderatorComment?: string | null, status: Types.ReservationStatus, createdAt: string, updatedAt: string, isPremium: boolean, branch?: { __typename?: 'BranchProxy', name: string, address: string, phones?: Array<{ __typename?: 'BranchPhoneProxy', phone: string }> | null, generalWorkSchedules?: Array<{ __typename?: 'BranchWorkScheduleProxy', id: number, period: string, day: { __typename?: 'DayProxy', id: number, name?: string | null, shortName?: string | null, number: number } }> | null, countryProxy?: { __typename?: 'CountryProxy', slug: string } | null, city?: { __typename?: 'CityProxy', slug: string } | null, branchDetails?: { __typename?: 'BranchDetailsProxy', slug: string, formatedAddress?: string | null } | null } | null, customPlace?: { __typename?: 'CustomPlaceProxy', id: number, name: string, location: string, country: { __typename?: 'CountryProxy', id: number, name: string } } | null, client: { __typename?: 'ClientProxy', name?: string | null, surname?: string | null, phone?: string | null, email?: string | null } }> | null } | null };

export type GetReservationByIdQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type GetReservationByIdQuery = { __typename?: 'bookingRestaurantQuery', reservationById?: { __typename?: 'ReservationProxy', id: number, uuid: any, reservationAt: string, flexibility: Types.ReservationFlexibility, guestsCount: number, comment?: string | null, moderatorComment?: string | null, status: Types.ReservationStatus, createdAt: string, updatedAt: string, isPremium: boolean, branch?: { __typename?: 'BranchProxy', name: string, address: string, phones?: Array<{ __typename?: 'BranchPhoneProxy', phone: string }> | null, generalWorkSchedules?: Array<{ __typename?: 'BranchWorkScheduleProxy', id: number, period: string, day: { __typename?: 'DayProxy', id: number, name?: string | null, shortName?: string | null, number: number } }> | null, countryProxy?: { __typename?: 'CountryProxy', slug: string } | null, city?: { __typename?: 'CityProxy', slug: string } | null, branchDetails?: { __typename?: 'BranchDetailsProxy', slug: string, formatedAddress?: string | null } | null } | null, customPlace?: { __typename?: 'CustomPlaceProxy', id: number, name: string, location: string, country: { __typename?: 'CountryProxy', id: number, name: string } } | null, client: { __typename?: 'ClientProxy', name?: string | null, surname?: string | null, phone?: string | null, email?: string | null } } | null };

export type ReservationChangeStatusMutationVariables = Types.Exact<{
  uuid: Types.Scalars['Uuid']['input'];
  status: Types.ReservationStatus;
  comment?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ReservationChangeStatusMutation = { __typename?: 'bookingRestaurantMutation', reservationChangeStatus: { __typename?: 'ReservationProxy', id: number, uuid: any, reservationAt: string, flexibility: Types.ReservationFlexibility, guestsCount: number, comment?: string | null, moderatorComment?: string | null, status: Types.ReservationStatus, createdAt: string, updatedAt: string } };
